export function getDenom(assetInfo) {
    if ('native_token' in assetInfo) {
        return assetInfo.native_token.denom;
    }
    return assetInfo.token.contract_addr;
}
